import { Box, Typography } from "@mui/material";
import { useOrganizationConfig } from "../api/organization";
import ClientsTable from "../components/ClientsTable";
import useIsLargeScreen from "../hooks/useIsLargeScreen";
import pluralizeString from "../utils/pluralizeString";

const ClientsListPage = () => {
    const isLargeScreen = useIsLargeScreen();
    const { giggedClientTerminology } = useOrganizationConfig();

    return (
        <>
            <Box sx={{ marginTop: "2rem", margin: ( isLargeScreen ?  3 : 2 )}}>
                <Typography component="h1" variant="h4" gutterBottom>{pluralizeString(giggedClientTerminology)}</Typography>
                <ClientsTable />
            </Box>
        </>
    );
};

export default ClientsListPage;